import React, { useEffect } from "react";
import { string } from "prop-types";
import { publicConfig } from "../../config";

const HubspotForm = ({ id, formId }) => {
	useEffect(() => {
		const hubspotFormCreate = () => {
			// eslint-disable-next-line no-undef
			hbspt.forms.create({
				portalId: `${publicConfig.HUBSPOT_PORTAL_ID}`,
				formId,
				region: "na1",
				target: `#${id}`,
			});
		};

		if (!document.getElementById("hubspot_script")) {
			const hubSpotScript = document.createElement("script");
			hubSpotScript.id = "hubspot_script";
			hubSpotScript.type = "text/javascript";
			hubSpotScript.src = "//js.hsforms.net/forms/v2.js";
			hubSpotScript.async = true;
			document.body.appendChild(hubSpotScript);
			hubSpotScript.onload = () => {
				hubspotFormCreate();
			};
		} else {
			hubspotFormCreate();
		}
	}, []);

	return <span id={id} />;
};
HubspotForm.propTypes = {
	id: string.isRequired,
	formId: string.isRequired,
};

export default HubspotForm;
